import { EnumConnector } from '../../../../../../api/com/MetaPattern/Core/Infrastructure/Exp/EnumConnector';
import { ConditionItem } from './ConditionItem';
import { Condition } from './Condition';

export class SubCondition {
  connector: EnumConnector;
  conditionItems: Array<ConditionItem>;
  condition: Condition;
}
